import React, { useState, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Card, Flex, Button, message, Skeleton, Typography } from 'antd';

import { CustomDatePicker } from '../../components/CustomDatePicker';

import { RemainingTimeContext } from '../../context/TimerContext';
import useEvaluation from '../../hooks/useAdminEvaluation';
import apis from '../../services/Apis';

import { table } from './struct';
import { SecureGet } from '../../services/axiosCall';

import { formRules } from '../../const/formRules';
import { TableDescription } from '../../components/TableDescription';

const { Paragraph } = Typography

const withTableController = (Table) => {
  // eslint-disable-next-line react/display-name
  return ({ currentApas, tableNo, dataConverter, hasReset, menu }) => {
    const apa = currentApas.find((item) => item.form_no === tableNo) || {};
    const [messageApi, contextHolder] = message.useMessage();

    const { timer } = useContext(RemainingTimeContext);

    const user = useSelector((state) => state.user);
    const { userDetails } = user;

    const [loading, setLoading] = useState(false);
    const handleLoading = (loading) => setLoading(loading);

    const [apaShortDes, setApaShortDes] = useState(null);
    const {
      form_no: formNo,
      form_name: formName,
      max_point: maxPoints
    } = apaShortDes || {};
    const handleApaShortDes = (des) => setApaShortDes(des);


    const [apaRules, setApaRules] = useState(null);
    const handleApaRules = (rules) => setApaRules(rules);



    const currentDate = new Date();
    const currentYear = currentDate.getFullYear() - 1;
    const [selectedYear, setSelectedYear] = useState(Number(currentYear));
    const handleSelectedYear = (_, yearString) =>
      setSelectedYear(Number(yearString));

    const { toTableData, toRequestData } = dataConverter || {};

    const fetchApaShortDes = (id) => {
      handleApaShortDes(null);
      handleLoading(true);

      SecureGet({ url: `${apis.FORM_LIST}/${id}` })
        .then((response) => {
          handleApaShortDes(response.data);
          handleLoading(false);
        })
        .catch(() => {
          handleLoading(false);
        });
    };

    const {
      planing,
      // updated,
      fetchLoading,
      updateLoading,
      updatePlaning,
      handlePlaning,
      // evaluatePlaning,
      // evaluateLoading,
      cumulativeApaPoints,
      status,
      // showEvaluate,
      semesterComments
    } = useEvaluation({
      url: apis.EVALUATION,
      formId: apa.id,
      userDetails: userDetails.user_id,
      rowUser: userDetails.user_id,
      selectedYear: selectedYear,
      messageApi: messageApi,
      convertToTableData: toTableData,
      convertToRequestData: toRequestData
    });

    useEffect(() => {
      if (menu?.currentApaId) fetchApaShortDes(menu?.currentApaId);
    }, [menu]);

    useEffect(() => {
      if (apaShortDes) {
        const _formRules = formRules.find((item) => formNo === item.id);
        const { rules } = _formRules || {};
        handleApaRules(rules);
      }
    }, [apaShortDes]);


    return (
      <Card {...table.wrapper}
        title={
          apaShortDes && !loading ? (
            <TableDescription
              formNo={menu?.currentMenuId}
              formName={formName}
              maxPoints={maxPoints}
              rules={apaRules}
              cumulativeApaPoints={cumulativeApaPoints}
              isEvaluation={true}
            />
          ) : null
        }
        styles={{
          header: {
            position: 'sticky',
            top: -16,
            zIndex: 1000,
            backgroundColor: 'inherit',
          }
        }}
      >
        {contextHolder}

        <br />
        <Flex {...table.header}>
          <CustomDatePicker
            selectedYear={selectedYear}
            handleSelectedYear={handleSelectedYear}
            isEvaluation={true}
          />
        </Flex>

        <br />

        {semesterComments && (
          <Paragraph>
            <strong>Comment:</strong> {semesterComments}
          </Paragraph>
        )}

        {/* {planing && !fetchLoading ?
          planing?.length > 0 ?
            <Table planing={planing} handlePlaning={handlePlaning} status={status} />
            : <Title level={4} style={{ textAlign: 'center', marginTop: 20 }}>
              No Data
            </Title> */}

        {planing && !fetchLoading ?
          <Table planing={planing} handlePlaning={handlePlaning} status={status} />

          :
          <Skeleton loading={fetchLoading} active />
        }

        <Typography.Text
          type="secondary"
          style={{ display: 'block', marginTop: 8, fontSize: 12, color: '#27be6b' }}
        >
          <strong>Note:</strong><br />
          1. Save after every change <br />
          2. The form will be locked after end of evaluation period.
        </Typography.Text>

        {/* <br /> */}
        <Flex {...table.header}>
          <div></div>

          {timer ? (
            <Flex {...table.actionsSection}>
              <Button
                {...table.saveButton}
                loading={updateLoading}
                onClick={() => updatePlaning()}
                disabled={status === 1 || status === 2 || status === 3}
              >
                Save
              </Button>

              {/* {
                showEvaluate &&
                <Button
                  {...table.evaluateButton}
                  loading={evaluateLoading}
                  onClick={() => evaluatePlaning()}
                  disabled={status === 1 || status === 2 || status === 3 || planing?.length === 0}
                >
                  {status === 1 || status === 2 || status === 3 ? 'Locked' : 'Lock'}
                </Button>
              } */}

              {hasReset && (
                <Button
                  {...table.resetButton}
                  loading={updateLoading}
                  onClick={() => handlePlaning([])}
                  disabled={status === 1 || status === 2 || status === 3}
                >
                  Reset
                </Button>
              )}


            </Flex>
          ) : (
            <></>
          )}
        </Flex>
      </Card>
    );
  };
};

export default withTableController;
